<template>
  <b-modal :title="helper.trans('labels.message_logs', {'device_name': logsModalDevice?.name})"
           dialog-class="modal-xl"
           :modelValue="logsModalDevice !== null"
           footer-class="d-flex justify-content-end"
           @update:modelValue="$event === false && (logsModalDevice = null)">
    <template #default>
      <DeviceMessageLogs :device="logsModalDevice!"></DeviceMessageLogs>
    </template>
    <template #footer>
      <button type="button" @click.prevent="logsModalDevice = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
        {{ helper.trans('button.ok')  }}
      </button>
    </template>
  </b-modal>
</template>

<script lang="ts">

import {defineComponent, PropType, Prop, watch, ref} from 'vue'
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import APIClient from "@/service/APIClient";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import {BModal} from "bootstrap-vue-3";
import DeviceMessageLogs from "@/components/DeviceMessageLogs.vue";

const api = new APIClient();

export default defineComponent({
  components: {
    BModal,
    DeviceMessageLogs
  },
  setup() {

    const state = reactive({
      logsModalDevice: null as TraderDeviceDTO|null,
    });

    const setDevice = (device: TraderDeviceDTO) => {
      state.logsModalDevice = device
    }

    return {
      ...toRefs(state),
      setDevice,
      dateHelper,
      numberFormatter,
      helper
    }
  }
})
</script>
